//Default guideline sizes are based on standard ~5" screen mobile device
import { Dimensions } from "react-native";

// Adjusted base dimensions for better scaling across devices
const SIZE_MATTERS_BASE_WIDTH = 375; // Standard iPhone width
const SIZE_MATTERS_BASE_HEIGHT = 812; // Standard iPhone height
const MAX_SCALE_MULTIPLIER = 1.3; // For mobile devices
const MIN_SCALE_MULTIPLIER = 0.95; // Increased to prevent elements from becoming too small on mobile

// Desktop-specific scaling
const DESKTOP_BREAKPOINT = 768; // Consider screens wider than this as desktop
const DESKTOP_MAX_SCALE_MULTIPLIER = 0.8; // Reduced scale for desktop
const DESKTOP_MIN_SCALE_MULTIPLIER = 0.6; // Minimum scale for desktop

const { width, height } = Dimensions.get("window");

// Get the shorter dimension for consistent scaling across orientations
const [shortDimension, longDimension] =
  width < height ? [width, height] : [height, width];

const guidelineBaseWidth = SIZE_MATTERS_BASE_WIDTH;
const guidelineBaseHeight = SIZE_MATTERS_BASE_HEIGHT;

// Calculate scale based on both dimensions
const widthScale = shortDimension / guidelineBaseWidth;
const heightScale = longDimension / guidelineBaseHeight;
const baseScale = Math.min(widthScale, heightScale);

// Detect if we're on desktop based on screen width
// const isDesktop = shortDimension >= DESKTOP_BREAKPOINT;
const isDesktop = window.innerWidth > DESKTOP_BREAKPOINT;

// Use different scale multipliers for desktop vs mobile
const maxScale = isDesktop
  ? DESKTOP_MAX_SCALE_MULTIPLIER
  : MAX_SCALE_MULTIPLIER;
const minScale = isDesktop
  ? DESKTOP_MIN_SCALE_MULTIPLIER
  : MIN_SCALE_MULTIPLIER;

// Ensure scale stays within reasonable bounds
const scale = Math.min(Math.max(baseScale, minScale), maxScale);

const moderateScale = (size: number, factor = 0.6) => {
  const scaledSize = size * scale;
  const diffSize = scaledSize - size;
  return size + diffSize * Math.min(factor, maxScale);
};

export const ms = moderateScale;
